import "./assets/styles/main.scss";

import { LanguageProvider } from "./components/LanguageContext";
import LiveTV from "./components/LiveTV";
import ChatBot from "./components/ChatBot";
import PreLoader from "./components/PreLoader";
import ReactDOM from "react-dom";

ReactDOM.render(
  <LanguageProvider>
    <>
      <PreLoader useLocalStorage={false} />
      <LiveTV />
      <ChatBot />
    </>
  </LanguageProvider>,
  document.querySelector("#app")
);
